module.exports = __webpack_public_path__ + "01b79352ae7b3b2d87ad93158b4232c8.pdf";